import { render } from "./MineRedesign.vue?vue&type=template&id=e3057d78&scoped=true"
import script from "./MineRedesign.vue?vue&type=script&lang=js"
export * from "./MineRedesign.vue?vue&type=script&lang=js"

import "./MineRedesign.vue?vue&type=style&index=0&id=e3057d78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3057d78"]])

export default __exports__